import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, toRef, nextTick } from 'vue';
import ChatView from "@/views/message/Chat.vue";
import Message from "@/views/message/Message.vue";
import { PlayerModel } from '@/model/playerModel';
import EventBus from '@/uitls/EventBus';
import IMUtils from "@/network/socket/imUtils";
import { useWindowSize } from '@vant/use'; 

export default /*#__PURE__*/_defineComponent({
  name: 'PlayerGroupChat',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "6c6a13e2-screenHeight": (screenHeight.value)
}))

const { width,  height } = useWindowSize();
const screenHeight = ref('');

const isSixin = ref(false);
const zb_chatkey = ref('');
const zb_autoMsg = ref('');

onMounted(() => {
    nextTick(() => {
        screenHeight.value = `${height.value}px`;
    });
});

const priviteGoback = () =>{
    isSixin.value = false;
    zb_chatkey.value = null;
};

const tochat = (chatKey) =>{
    zb_chatkey.value = chatKey;
    isSixin.value = true;
};



const __returned__ = { width, height, screenHeight, isSixin, zb_chatkey, zb_autoMsg, priviteGoback, tochat, ChatView, Message }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})